define(
    'plugins/musicfavourite/ui/dom',['../vendor'],
    function(vendor) {
        return {
            'on': function(elem, eventType, handler) {
                return vendor.bean.on(elem, eventType, handler);
            },

            'off': function(elem, eventType, handler) {
                if (handler) {
                    return vendor.bean.off(elem, eventType, handler);
                }
                else if (eventType) {
                    return vendor.bean.off(elem, eventType);
                } else {
                    return vendor.bean.off(elem);
                }
            },

            'empty': function(e) {
                return vendor.bonzo(e).empty();
            },

            'findElement': function(selector, context) {
                selector = selector || null;
                context  = context  || null;

                return vendor.qwery(selector, context);
            },

            'parseData': function(elem) {
                return vendor.bonzo(elem).data();
            },

            'getData': function(elem, key) {
                return vendor.bonzo(elem).data(key);
            },

            'setData': function(elem, key, value) {
                vendor.bonzo(elem).data(key, value);
            },

            'addClass': function(e, c) {
                return vendor.bonzo(e).addClass(c);
            },

            'removeClass': function(e, c) {
                return vendor.bonzo(e).removeClass(c);
            },

            'hasClass': function(e, c) {
                return vendor.bonzo(e).hasClass(c);
            },

            'getHTML': function(e) {
                return vendor.bonzo(e).html();
            },

            'setHTML': function(e, h) {
                return vendor.bonzo(e).html(h);
            },

            'setText': function(e, t) {
                return vendor.bonzo(e).text(t);
            },

            'getAttr': function(e, a) {
                return vendor.bonzo(e).attr(a);
            },

            'setAttr': function(e, a, v) {
                return vendor.bonzo(e).attr(a, v);
            },

            'focus': function(e) {
                return vendor.bonzo(e).focus();
            },

            'blur': function(e) {
                return vendor.bonzo(e).blur();
            },

            'show': function(e) {
                return vendor.bonzo(e).show();
            },

            'hide': function(e) {
                return vendor.bonzo(e).hide();
            },

            'isHidden': function(e) {
                return this.getAttr(e, 'style').indexOf('display: none') != -1;
            },

            'append': function(e, h) {
                return vendor.bonzo(e).append(h);
            },
                    
            'prepend': function(e, h) {
                return vendor.bonzo(e).prepend(h);
            },
                    
            'css': function(e, c) {
                return vendor.bonzo(e).css(c);
            },

            'offset': function(e) {
                return vendor.bonzo(e).offset();
            },

            'parent': function(e) {
                return vendor.bonzo(e).parent();
            },

            'findClosestParent': function (element, selector) {
                for (; element && element !== document && element.nodeType === 1; element = element.parentNode) {
                    if ((selector.indexOf('.') !== -1 && this.hasClass(element, selector.substr(1))) ||
                        (selector.indexOf('#') !== -1 && this.getAttr(element, "id") == selector.substr(1))) {
                        return element;
                    }
                }
            }

        };
    }
);

